module.exports = __webpack_public_path__ + "static/media/phone-herdie.6805792f.svg";